import React, { FC } from 'react';
import { connect } from 'react-redux';

import ComposeMetaOffset from '../../../components/Compose/Common/ComposeMeta/ComposeMetaOffset';
import Offset from '../../../components/MUI/Compose/Offset';
import MetaOffset from '../../../components/MetaOffset';
import useComposeType from '../../../hooks/router/search/useComposeType';
import useIsMobile from '../../../hooks/useIsMobile';
import { ComposeModeParam } from '../../../models/pageParams';

import useComposeLinking from '../hooks/useComposeLinking';

import { mapDispatchToProps, mapStateToProps } from './redux';
import { Props } from './types';

/**
 * Manage template due date offset
 *
 * @param props                         Props passed to the container
 * @param props.dataOffsetCurrent       Currently selected offset
 * @param props.dataOffsetSaved         Saved offset
 * @param props.dataRemindersCurrent    Currently created reminders
 * @param props.dataRemindersSaved      Saved reminders
 * @param props.requestOffsetRemove     Request that the offset is cleared
 * @param props.requestOffsetSave       Request current -> saved store
 * @param props.requestOffsetSaveNew    Request that the offset is saved
 * @param props.requestRemindersSaveNew Request that the reminders are saved
 * @returns                             The container itself
 */
const ComposeMetaOffsetContainer: FC<Props> = ({
  dataOffsetCurrent,
  dataOffsetSaved,
  dataRemindersCurrent,
  dataRemindersSaved,
  requestOffsetRemove,
  requestOffsetSaveNew,
  requestRemindersSaveNew,
}) => {
  const isMobile = useIsMobile();
  const mode: ComposeModeParam = 'offset';
  const { isActive, linkToggleProps } = useComposeLinking(mode);
  const composeType = useComposeType();

  // Due date should not be available for posts, only for tasks
  if (composeType === 'post') {
    return;
  }

  if (isMobile) {
    return (
      <MetaOffset
        dataOffsetCurrent={dataOffsetCurrent}
        dataOffsetSaved={dataOffsetSaved}
        dataRemindersCurrent={dataRemindersCurrent}
        dataRemindersSaved={dataRemindersSaved}
        inputCustom={<ComposeMetaOffset offset={dataOffsetSaved} />}
        isActive={isActive}
        linkToggleProps={linkToggleProps}
        requestOffsetRemove={requestOffsetRemove}
      >
        <Offset
          dataOffsetCurrent={dataOffsetCurrent}
          dataOffsetSaved={dataOffsetSaved}
          dataRemindersSaved={dataRemindersSaved}
          requestOffsetSave={requestOffsetSaveNew}
          requestRemindersSave={requestRemindersSaveNew}
        />
      </MetaOffset>
    );
  }

  return (
    <Offset
      dataOffsetCurrent={dataOffsetCurrent}
      dataOffsetSaved={dataOffsetSaved}
      dataRemindersSaved={dataRemindersSaved}
      requestOffsetSave={requestOffsetSaveNew}
      requestRemindersSave={requestRemindersSaveNew}
    />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ComposeMetaOffsetContainer);
